import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Links from '@mui/material/Link';

import { Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {

    return (
        <Box id="AppBoardScreen1" className="AppBoardScreen AppBoardScreen1" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12}>
                    <h2 className="subHeading">¿Que servicio necesita el día de hoy?</h2>
                </Grid>
                <Grid item xs={12}>
                    <Button className="RenovaciónDePlacas" variant="outlined" size="large">Renovación de placas</Button>
                </Grid>
                <Grid item xs={12}>
                    <Tooltip title="Pagar tarifas anuales del DMV para un vehículo Pregunta Clave: ¿Quiere obtener el sticker anual que va en la esquina de la placa?" placement="top">
                        <Button className="CambioDeNombre" variant="outlined" size="large">Cambio de nombre</Button>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    <Button className="ReemplazoDeRegistración" variant="outlined" size="large">Reemplazo de registración</Button>
                </Grid>
                <Grid item xs={12}>
                    <Button className="ReporteDeVenta" variant="outlined" size="large">Reporte de venta</Button>
                </Grid>
                <Grid item xs={12}>
                    <Links href="https://www.aseguranzadeauto.com/broker-logins/" target="_blank" rel="noreferrer" underline="always">{'Insurance'}</Links>
                </Grid>

                <Grid item xs={6} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/placas">
                        <Button className="PrevButton" variant="outlined" size="large">Previa</Button>
                    </Link>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <Link to="/dmv/placas/RegistrationRequireInfo">
                        <Button className="NextButton" variant="contained" size="large">Próxima</Button>
                    </Link>
                </Grid>
                <Outlet />

            </Grid>
        </Box>
    );
};

export default AppBoardScreen;